import { render, staticRenderFns } from "./LogsTableSerial.vue?vue&type=template&id=58f151bf&"
import script from "./LogsTableSerial.vue?vue&type=script&lang=js&"
export * from "./LogsTableSerial.vue?vue&type=script&lang=js&"
import style0 from "./LogsTableSerial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports